/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateRecordingEnvelopePayloadRelease
 */
export interface CreateRecordingEnvelopePayloadRelease {
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRelease
     */
    releaseId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRelease
     */
    dateReleased?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRelease
     */
    releaseTitle?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRecordingEnvelopePayloadRelease
     */
    releaseLabels?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRecordingEnvelopePayloadRelease
     */
    catNumbers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRelease
     */
    mediaType?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRelease
     */
    format?: string;
    /**
     * Release barcode: 12-digit UPC or 13-digit EAN. Spaces and hyphens are ignored.
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRelease
     */
    barcode?: string;
    /**
     * The release's id(s) at its source, e.g. the Discogs release id the lookup was made with. `release_id` is the WMC ParentRelease id, so without this the source's own id never reaches `sourceReleaseId`.
     * @type {Array<string>}
     * @memberof CreateRecordingEnvelopePayloadRelease
     */
    sourceReleaseIds?: Array<string>;
    /**
     * Must name the same source as the recording (4.1.4.4).
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRelease
     */
    source: CreateRecordingEnvelopePayloadReleaseSourceEnum;
    /**
     * Release id at the source. Present means create-and-link; absent means link `release_id`.
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRelease
     */
    sourceId?: string;
}


/**
 * @export
 */
export const CreateRecordingEnvelopePayloadReleaseSourceEnum = {
    Discogs: 'discogs',
    Musicbrainz: 'musicbrainz',
    Spotify: 'spotify',
    Deezer: 'deezer',
    Ppl: 'ppl',
    Other: 'other'
} as const;
export type CreateRecordingEnvelopePayloadReleaseSourceEnum = typeof CreateRecordingEnvelopePayloadReleaseSourceEnum[keyof typeof CreateRecordingEnvelopePayloadReleaseSourceEnum];


/**
 * Check if a given object implements the CreateRecordingEnvelopePayloadRelease interface.
 */
export function instanceOfCreateRecordingEnvelopePayloadRelease(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "source" in value;

    return isInstance;
}

export function CreateRecordingEnvelopePayloadReleaseFromJSON(json: any): CreateRecordingEnvelopePayloadRelease {
    return CreateRecordingEnvelopePayloadReleaseFromJSONTyped(json, false);
}

export function CreateRecordingEnvelopePayloadReleaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRecordingEnvelopePayloadRelease {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'releaseId': !exists(json, 'release_id') ? undefined : json['release_id'],
        'dateReleased': !exists(json, 'dateReleased') ? undefined : json['dateReleased'],
        'releaseTitle': !exists(json, 'releaseTitle') ? undefined : json['releaseTitle'],
        'releaseLabels': !exists(json, 'releaseLabels') ? undefined : json['releaseLabels'],
        'catNumbers': !exists(json, 'catNumbers') ? undefined : json['catNumbers'],
        'mediaType': !exists(json, 'mediaType') ? undefined : json['mediaType'],
        'format': !exists(json, 'format') ? undefined : json['format'],
        'barcode': !exists(json, 'barcode') ? undefined : json['barcode'],
        'sourceReleaseIds': !exists(json, 'source_release_ids') ? undefined : json['source_release_ids'],
        'source': json['source'],
        'sourceId': !exists(json, 'source_id') ? undefined : json['source_id'],
    };
}

export function CreateRecordingEnvelopePayloadReleaseToJSON(value?: CreateRecordingEnvelopePayloadRelease | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'release_id': value.releaseId,
        'dateReleased': value.dateReleased,
        'releaseTitle': value.releaseTitle,
        'releaseLabels': value.releaseLabels,
        'catNumbers': value.catNumbers,
        'mediaType': value.mediaType,
        'format': value.format,
        'barcode': value.barcode,
        'source_release_ids': value.sourceReleaseIds,
        'source': value.source,
        'source_id': value.sourceId,
    };
}

